import { useQuery } from '@apollo/client';
import ListTemplate from 'components/template/ListTemplate';
import { format, startOfMonth } from 'date-fns';
import { GRAPHQL_RELATORIO_SAQUE_TAXAS } from 'gql/saque';
import React, { FC, useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import JSON_DATA_HEADER from './data/header.json';
import { IRelatorioSaqueTaxas } from './hooks/index.d';
import { useQueryFilterSaques } from './hooks/useQueryFilterSaques';
import { useTransformSaques } from './hooks/useTransformSaques';
import { BotaoConfiguracao, Resumo, Toolbar } from './styl';

const STATUS = [
    { value: '', label: 'Todos' },
    { value: 'AGUARDANDO_APROVACAO', label: 'Aguardando aprovação' },
    { value: 'PENDENTE', label: 'Pendente' },
    { value: 'PROCESSANDO', label: 'Processando' },
    { value: 'CONCLUIDO', label: 'Concluído' },
    { value: 'FALHOU', label: 'Falhou' },
    { value: 'CANCELADO', label: 'Cancelado' },
    { value: 'REPROVADO', label: 'Reprovado' },
];

const moeda = (valor?: number) =>
    new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).format(valor || 0);

const PageListSaques: FC<any> = () => {
    const history = useHistory();
    const [filtro, setFiltro] = useState({
        status: '',
        dataInicial: format(startOfMonth(new Date()), 'yyyy-MM-dd'),
        dataFinal: format(new Date(), 'yyyy-MM-dd'),
    });
    const props = useQueryFilterSaques();

    // Taxas arrecadadas: saques pagos no período, pela data do pagamento
    const { data: relatorio, refetch } = useQuery<IRelatorioSaqueTaxas>(
        GRAPHQL_RELATORIO_SAQUE_TAXAS,
        {
            variables: {
                dataInicial: filtro.dataInicial,
                dataFinal: filtro.dataFinal,
            },
            skip: !filtro.dataInicial || !filtro.dataFinal,
            fetchPolicy: 'network-only',
        }
    );
    const onAtualizado = useCallback(() => {
        refetch?.();
    }, [refetch]);
    const data = useTransformSaques({ ...props, onAtualizado });

    const handleFiltro = useCallback(
        (campo: string, valor: string) => {
            const novo = { ...filtro, [campo]: valor };
            setFiltro(novo);
            props.handleSearch(novo);
        },
        [filtro, props.handleSearch]
    );

    // A lista começa com o mesmo período do resumo de taxas
    useEffect(() => {
        props.handleSearch(filtro);
    }, []);

    const taxas = relatorio?.relatorioSaqueTaxas;
    return (
        <>
            <Toolbar>
                <label>
                    Status
                    <select
                        value={filtro.status}
                        onChange={(e) => handleFiltro('status', e.target.value)}>
                        {STATUS.map(({ value, label }) => (
                            <option key={value} value={value}>
                                {label}
                            </option>
                        ))}
                    </select>
                </label>
                <label>
                    De
                    <input
                        type="date"
                        value={filtro.dataInicial}
                        max={filtro.dataFinal}
                        onChange={(e) =>
                            handleFiltro('dataInicial', e.target.value)
                        }
                    />
                </label>
                <label>
                    Até
                    <input
                        type="date"
                        value={filtro.dataFinal}
                        min={filtro.dataInicial}
                        onChange={(e) =>
                            handleFiltro('dataFinal', e.target.value)
                        }
                    />
                </label>
                <Resumo>
                    <div>
                        Saques pagos no período
                        <strong>{taxas?.qtdeSaques ?? 0}</strong>
                    </div>
                    <div>
                        Valor pago
                        <strong>{moeda(taxas?.totalLiquido)}</strong>
                    </div>
                    <div>
                        Taxas arrecadadas
                        <strong>{moeda(taxas?.totalTaxas)}</strong>
                    </div>
                </Resumo>
                <BotaoConfiguracao
                    type="button"
                    onClick={() => history.push('/admin/saques/configuracao')}>
                    Configurações
                </BotaoConfiguracao>
            </Toolbar>
            <ListTemplate
                browserTitle="Saques"
                colunas={JSON_DATA_HEADER}
                data={data}
                disableFilter
                {...props}
            />
        </>
    );
};

export default PageListSaques;
